$(document).ready(function () {

  $('#product__slider').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 4,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    arrows: false,
    centerMode: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  })
  $('#toddler--slider-outer').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  })
  $('#testi-outer').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplaySpeed: 2000,
    dots: true,
    arrows: false,
  })
  var winWidth = $(window).width()
  if (winWidth < 992) {
    // alert('active')
    $('#hadnpicked-slider').slick({
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 2,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    })
  }

  $('#shop__cat--slider').slick({
    centerMode: true,
    centerPadding: '10px',
    slidesToShow: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    fade: true,
    arrows: true,
  })

})